"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardSecretBatchDeleteApi = cardSecretBatchDeleteApi;
exports.cardSecretDeleteApi = cardSecretDeleteApi;
exports.cardSecretImportExcelApi = cardSecretImportExcelApi;
exports.cardSecretPageListApi = cardSecretPageListApi;
exports.cardSecretSaveApi = cardSecretSaveApi;
exports.cardSecretUpdateApi = cardSecretUpdateApi;
exports.productCdkeyDeleteApi = productCdkeyDeleteApi;
exports.productCdkeyListApi = productCdkeyListApi;
exports.productCdkeysaveApi = productCdkeysaveApi;
exports.productUnrelatedListApi = productUnrelatedListApi;
exports.productUnrelatedUpdateApi = productUnrelatedUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 删除卡密库
 * @param id
 */
function productCdkeyDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/cdkey/library/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 卡密库分页列表
 * @param params
 */
function productCdkeyListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/cdkey/library/page/list",
    method: 'get',
    params: params
  });
}

/**
 * 新增卡密库
 * @param data
 */
function productCdkeysaveApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/cdkey/library/save",
    method: 'post',
    data: data
  });
}

/**
 * 未关联卡密库列表
 * @param params
 */
function productUnrelatedListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/cdkey/library/unrelated/list",
    method: 'get',
    params: params
  });
}

/**
 * 修改卡密库
 * @param data
 */
function productUnrelatedUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/cdkey/library/update",
    method: 'post',
    data: data
  });
}

/**
 * 删除卡密
 * @param id
 */
function cardSecretDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/card/secret/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 导入卡密
 * @param data
 */
function cardSecretImportExcelApi(data, params) {
  return (0, _request.default)({
    url: "/admin/merchant/card/secret/import/excel",
    method: 'post',
    data: data,
    params: params
  });
}

/**
 * 卡密分页列表
 * @param params
 */
function cardSecretPageListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/card/secret/page/list",
    method: 'get',
    params: params
  });
}

/**
 * 新增卡密
 * @param data
 */
function cardSecretSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/card/secret/save",
    method: 'post',
    data: data
  });
}

/**
 * 修改卡密
 * @param data
 */
function cardSecretUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/card/secret/update",
    method: 'post',
    data: data
  });
}

/**
 * 批量删除卡密
 * @param data
 */
function cardSecretBatchDeleteApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/card/secret/batch/delete",
    method: 'post',
    data: data
  });
}